import { render, staticRenderFns } from "./V2Shipment.vue?vue&type=template&id=4d9d7c47&"
import script from "./V2Shipment.vue?vue&type=script&lang=js&"
export * from "./V2Shipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports